"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _extensionDocument = _interopRequireDefault(require("@tiptap/extension-document"));

var _extensionParagraph = _interopRequireDefault(require("@tiptap/extension-paragraph"));

var _extensionText = _interopRequireDefault(require("@tiptap/extension-text"));

var _extensionLink = _interopRequireDefault(require("@tiptap/extension-link"));

var _react2 = require("@tiptap/react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Label = _interopRequireDefault(require("./Label"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

var _TextAreaInput = _interopRequireDefault(require("./TextAreaInput"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledEditor = (0, _styledComponents.default)(_react2.EditorContent)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 8rem;\n    overflow-y: scroll;\n    border-color: hsl(0,0%,90%);\n    border-radius: 0;\n    border-style: solid;\n    border-width: 1px;\n    background-color: ", ";\n\n    .ProseMirror {\n        min-height: 6rem;\n        margin: 0 1rem;\n\n        a {\n            color: -webkit-link;\n            cursor: pointer;\n            text-decoration: underline;\n        }\n    }\n\n    .ProseMirror-focused {\n        outline: none;\n    }\n"])), function (props) {
  return props.disabled ? "#f7f7f7" : "#fff";
});

var RichTextInput = function RichTextInput(_ref) {
  var id = _ref.id,
      onChange = _ref.onChange,
      label = _ref.label,
      labelTooltip = _ref.labelTooltip,
      fieldDescription = _ref.fieldDescription,
      errors = _ref.errors,
      postErrors = _ref.postErrors,
      postErrorHandler = _ref.postErrorHandler,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      disabled = _ref.disabled,
      t = _ref.t;
  var initialValue = (options === null || options === void 0 ? void 0 : options.initialValue) || '';

  var handleEditorChange = function handleEditorChange(_ref2) {
    var editor = _ref2.editor;
    var json = editor.getHTML();
    postErrors && postErrorHandler(id);
    onChange(id, json);
  };

  var editor = (0, _react2.useEditor)({
    content: initialValue,
    onUpdate: handleEditorChange,
    extensions: [_extensionDocument.default, _extensionParagraph.default, _extensionText.default, _extensionLink.default],
    editable: !disabled
  }, [initialValue]);
  return _react.default.createElement(_react.default.Fragment, null, label && _react.default.createElement(_Label.default, {
    customLabel: label,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(StyledEditor, {
    id: id,
    editor: editor,
    disabled: disabled
  }), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var _default = RichTextInput;
exports.default = _default;